export const MILESTONE_DETAILS = {
  booking_confirmed: {
    label: "Booking Confirmed",
    description: "Your date is reserved with Gledswood and the planning journey can begin.",
  },
  deposit_paid: {
    label: "Deposit Paid",
    description: "Your booking deposit has been received by the Gledswood team.",
  },
  contract_signed: {
    label: "Contract Signed & Returned",
    description: "Your signed event agreement is recorded with the venue.",
  },
  wedding_timings: {
    label: "Event Timings Confirmed",
    description: "The essential timing framework for your celebration has been confirmed.",
  },
  ceremony: {
    label: "Ceremony Options Selected",
    description: "Your ceremony location, format and key moments can be shared with the team.",
  },
  suppliers: {
    label: "Supplier Details",
    description: "Keep the contact details for your booked suppliers together for the event team.",
  },
  planning_meeting_6m: {
    label: "6 Month Planning Meeting",
    description: "A planning checkpoint to align the bigger decisions for your celebration.",
  },
  menu: {
    label: "Wedding Menu Selections",
    description: "Record your menu choices so the kitchen and event team can review them.",
  },
  guest_numbers: {
    label: "Guest Numbers & Dietary Requirements",
    description: "Track guest responses, final numbers and every dietary requirement in one place.",
  },
  guest_list_floor_plan: {
    label: "Guest List & Floor Plan",
    description: "Use your final list alongside Gledswood-issued floor plan information.",
  },
  social_media_consent: {
    label: "Social Media Consent",
    description: "Let Gledswood know how photography and video from your event may be shared.",
  },
  final_meeting: {
    label: "Final Planning Meeting & Walkthrough",
    description: "Review the final details and walk through the day with your event team.",
  },
  the_big_day: {
    label: "The Big Day!",
    description: "Everything is aligned for your Gledswood celebration.",
  },
};

export function milestoneContent(milestone) {
  const known = MILESTONE_DETAILS[milestone?.key];
  return {
    label: known?.label || milestone?.label || "Planning milestone",
    description: known?.description || "Your Gledswood team will guide you through this step.",
  };
}

export function formatEventSchedule(date, time) {
  if (!date) {
    return "Date to be confirmed";
  }
  const day = new Date(`${date}T12:00:00`).toLocaleDateString("en-AU", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  if (!time) {
    return day;
  }
  const clock = new Date(`1970-01-01T${time}`).toLocaleTimeString("en-AU", {
    hour: "numeric",
    minute: "2-digit",
  });
  return `${day} · ${clock}`;
}